module.exports = __webpack_public_path__ + "static/team-anshul-arora-541e6e73ff10beadc9e60a42d2e97b47.jpeg";